import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: "root",
})
export class FetchImageBase64FromUrl {
  constructor(private http: HttpClient) {}

  /**
   * @description function to get an image from a url as base64
   * @param imageUrl the url of the image to be fetched
   * @returns Base64 image
   */
  async fetchBase64ImageFromUrl(imageUrl) {
    try {
      const data = await this.http
        .get(imageUrl + `?v=${new Date().getTime()}`, { responseType: 'blob' })
        .toPromise();
      const blob = new Blob([data], { type: `image/png` });
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.log("error FetchImageBase64FromUrl: fetchBase64ImageFromUrl");
    }
  }
}
